import * as React from "react";
import { BooleanField, BooleanInput, Create, Datagrid, DateField, Edit, List, NumberInput, ReferenceField, ReferenceInput, required, SelectInput, SimpleForm, TextField, TextInput } from "react-admin";

export const ContractCreate = () => (
<Create>
<SimpleForm>
    <ReferenceInput source="parent_company_id" reference="parent_companies"><SelectInput optionText="name" optionValue="id" /></ReferenceInput>
    <BooleanInput source="active" defaultValue={true}/>
    <SelectInput source="currency" choices={[
                    { id: 'INR', name: 'INR' },
                    { id: 'USD', name: 'USD' },
                    { id: 'JPY', name: 'JPY' },
                ]} defaultValue='INR'/>
    <SelectInput source="type" choices={[
                    { id: 'add-0', name: 'Original' },
                    { id: 'add-1', name: 'Addendum-1' },
                    { id: 'add-2', name: 'Addendum-2' },
                    { id: 'add-3', name: 'Addendum-3' },
                    { id: 'add-4', name: 'Addendum-4' },
                    { id: 'add-5', name: 'Addendum-5' },
                    { id: 'add-6', name: 'Addendum-6' },
                ]} defaultValue='add-0' />
    <TextInput source="description" fullWidth validate={required()} />
    <NumberInput source="contract_value" fullWidth validate={required()} />
    <NumberInput source="intl_experta" label="International Key Expert Contract Value" fullWidth />
    <NumberInput source="intl_non_experta" label="International Non Key Expert Contract Value" fullWidth/>
    <NumberInput source="ntl_expertb" label="National Key Expert Contract Value" fullWidth />
    <NumberInput source="ntl_non_expertb" label="National Non Key Expert Contract Value" fullWidth />
    <NumberInput source="support_staff" label="Supporting Staff Contract Value" fullWidth />
    <NumberInput source="provisional_sums" label="Provisional Sums Value" fullWidth />
    <NumberInput source="contingencies" label="Contingencies Value" fullWidth />
    <TextInput source="start_month_raw" label="Start Month (YYYYMM)" fullWidth />
    <TextInput source="end_month_raw" label="End Month (YYYYMM)" fullWidth />
</SimpleForm>
</Create>
);

export const ContractEdit = () => (
<Edit>
<SimpleForm>
    <ReferenceField source="parent_company_id" reference="parent_companies"><TextField optionText="name" optionValue="id" /></ReferenceField>
    <BooleanInput source="active" defaultValue={true}/>
    <SelectInput source="currency" choices={[
                    { id: 'INR', name: 'INR' },
                    { id: 'USD', name: 'USD' },
                    { id: 'JPY', name: 'JPY' },
                ]} defaultValue='INR'/>
    <SelectInput source="type" choices={[
                    { id: 'add-0', name: 'Original' },
                    { id: 'add-1', name: 'Addendum-1' },
                    { id: 'add-2', name: 'Addendum-2' },
                    { id: 'add-3', name: 'Addendum-3' },
                    { id: 'add-4', name: 'Addendum-4' },
                    { id: 'add-5', name: 'Addendum-5' },
                    { id: 'add-6', name: 'Addendum-6' },
                ]} defaultValue='add-0' />
    <TextInput source="description" fullWidth validate={required()} />
    <NumberInput source="contract_value" fullWidth validate={required()} />
    <NumberInput source="intl_experta" label="International Key Expert Contract Value" fullWidth />
    <NumberInput source="intl_non_experta" label="International Non Key Expert Contract Value" fullWidth/>
    <NumberInput source="ntl_expertb" label="National Key Expert Contract Value" fullWidth />
    <NumberInput source="ntl_non_expertb" label="National Non Key Expert Contract Value" fullWidth />
    <NumberInput source="support_staff" label="Supporting Staff Contract Value" fullWidth />
    <NumberInput source="provisional_sums" label="Provisional Sums Value" fullWidth />
    <NumberInput source="contingencies" label="Contingencies Value" fullWidth />
    <TextInput source="start_month_raw" label="Start Month (YYYYMM)" fullWidth />
    <TextInput source="end_month_raw" label="End Month (YYYYMM)" fullWidth />
</SimpleForm>
</Edit>
);

export const ContractList = () => (
<List>
<Datagrid rowClick="show">
    <TextField source="id" />
    <TextField source="description" />
    <ReferenceField source="parent_company_id" reference="parent_companies"><TextField source="name" /></ReferenceField>
    <BooleanField source='active' />
    <TextField source="currency" />
    <DateField source="createdAt" />
    <DateField source="updatedAt" />
</Datagrid>
</List>
);